


declare var window: any;
import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { AdditionalDocument } from '@/models/additionaldocuments/additionaldocument';
import { SkillDocument } from '@/models/skills/skilldocument';
import { DocumentResponse } from '@/models/skills/documentresponse';
import { DocumentPayload } from '@/models/skills/documentpayload';
import RegistrationCard from '@/components/Registration/Card.vue';
import { vxm } from './../../store.vuex';
import Datepicker from 'vuejs-datepicker';
import {en, de, es, fr} from 'vuejs-datepicker/dist/locale';
import { AdditionalDocResponse } from '@/models/additionaldocuments/additionaldocresponse';
import UploadModel from './UploadDocumentsModel.vue';
import { AdditionalDocumentPayload } from '@/models/additionaldocuments/additionaldocumentpayload';
import { DocumentTypeResponse } from '@/models/additionaldocuments/documenttyperesponse';
import GuidedSignupUtilities from '@/components/GuidedSignup/utilities';
import Loader from '../Loader.vue';
import moment from 'moment';
import ProfilePlaceholder from '@/components/Commons/ProfilePlaceholder.vue';
import AddEntity from '@/components/Commons/AddEntity.vue';
import AddDocument from '@/components/MyProfile/AddDocument.vue';
import { BFormFile } from 'bootstrap-vue/es/components';
import VueGoogleAutocomplete from 'vue-google-autocomplete';

import { DEFAULT_ADDITIONAL_DOCUMENT_FORMATS } from '@/models/additionaldocuments/defaultAdditionalDocumentFormats';
@Component({
  name: 'MyDocuments',
  components: {
    RegistrationCard,
    Datepicker,
    UploadModel,
    Loader,
    ProfilePlaceholder,
    AddEntity,
    AddDocument,
    VueGoogleAutocomplete,
  },
})
export default class AdditionalDocumentsV2 extends Mixins(
  GuidedSignupUtilities,
) {
  private additionalDocuments: Document[] = [];
  private uploadDocument: boolean = false;
  private addtionalDocument: AdditionalDocument = new AdditionalDocument();
  private documentExpires: boolean = false;
  private replaceUploadedDocument: boolean = false;
  private selectedDocument: AdditionalDocResponse = new AdditionalDocResponse();
  private isDropBoxFileUploaded: boolean = false;
  private editMode: boolean = false;
  public documentList: AdditionalDocResponse[] = [];
  public myDocumentList: AdditionalDocResponse[] = [];
  private editDeleteHeader: string = '';
  private editDeleteBody: string = '';
  private supportedFileSize = 0;
  private documentPayload: AdditionalDocumentPayload = new AdditionalDocumentPayload();
  private dropBoxFile?: string;
  private dropBoxFileName?: string;
  private documentType: DocumentTypeResponse[] = [];
  private selectedDocumentType: string = '';
  private userAttributeDocument: SkillDocument = new SkillDocument();
  private userAttributePayload: DocumentPayload = new DocumentPayload();
  private searchUploadDocument: SkillDocument = new SkillDocument();
  private showModalEdit: boolean = false;
  private uploadUserAttribute: boolean = false;
  private userAttributeID: number = 0;
  private selectedUserAttribute: DocumentResponse = new DocumentResponse();

  private startDate: any;
  private effectiveDateStr: string = '';
  private licenseState: string = '';
  private licenseNumber: string = '';

  private effectiveDTTMText: string = '';
  private expiryDTTMText: string = '';

  private validCredential: boolean = false;

  $wlToastr: any;
  $moment: any;
  @Prop({ default: () => new Vue(), type: Vue }) bus;
  @Prop({ default: false }) isRequiredStep;
  @Prop({ default: 0 }) minimumEntries;
  @Prop () isLastStep;
  get getLanguage() {
    const lang = vxm.users.getUserLang || 'en';
    return {en, de, es, fr}[lang];
  }

  beforeDestroy() {
    this.bus.$off('on-next-step');
  }
 
  async mounted() {
    this.$emit('disable-next-button', this.shouldDisableButton());
    await vxm.users.validateMandatorySteps();
    this.bus.$on('on-next-step', () => {
        if (!this.shouldDisableButton()) {
          if(vxm.users.MissedMandatorySteps.length && this.isLastStep) {
             this.$emit('missed-mandatory', vxm.users.MissedMandatorySteps);
          }else{
             this.$emit('go-to-next');
          }
        }
    });
    await vxm.documents.getUserDocumentData();
    this.documentList = vxm.documents.AdditionalDocumentList;
    this.documentTypeList();
    this.updateDocuments();
    this.supportedFileSize = vxm.utility.fileUploadMaxSize;
    this.selectedDocumentType = '';
    if (vxm.configs.getGlobalConfigValue('TURN_ON_CREDENTIALING')) {
        await vxm.documents.getMyDocumentData();
        this.myDocumentList = vxm.documents.MyDocumentList;
        this.updateDocuments();
    }
}
  private shouldDisableButton(): boolean {
    // This assumes `this.documentList.length` as the current number of entries. Adjust if necessary.
    console.log("this.documentList.length ",this.documentList.length)
    console.log("this.documentList ",this.documentList)
    console.log("this.minimumEntries ",this.minimumEntries)
    console.log("this ",this)
    
    const x = this.isRequiredStep && this.documentList.length < this.minimumEntries;
    console.log("x",x);
    return x
}
updateDocuments() {
    // This method should be called after any operation that modifies the number of documents
    this.$emit('disable-next-button', this.shouldDisableButton());
}

  get getCompanyDateFormat() {
    return vxm.jobs.getCompanyDateFormat;
  }

  get companyCode() {
    return vxm.jobs.BrandingInfo.companycode;
  }

  get canShowLicenceInfo() {
    return vxm.configs.getGlobalConfigValue('SKILL_DOCUMENT_LICENCE_INFO');
  }

  userPermissionConfig(permission){
    return vxm.configs.getUserPermissionConfig(permission,'MY_DOCUMENTS');
  }

  get allowedDocumentFormatText(): string {
    const array = (
      vxm.configs.getGlobalConfigValue('ADDITIONAL_DOCUMENT_FORMATS') ||
      DEFAULT_ADDITIONAL_DOCUMENT_FORMATS
    ).split(',');
    return vxm.utility.commaAndSeparator(array);
  }

  get allowedDocumentFormat() {
    return (
      vxm.configs.getGlobalConfigValue('ADDITIONAL_DOCUMENT_FORMATS') ||
      DEFAULT_ADDITIONAL_DOCUMENT_FORMATS
    ).split(',');
  }

  get maxFileSize(): number {
    return (
      (vxm.utility.fileUploadMaxSize) / (1024 * 1024)
    );
  }
  get sectionSubHeader(){
    if( this.minimumEntries>1 && this.userPermissionConfig('edit')){
      return `Please upload at least ${
          this.minimumEntries
        } additional documents`
    }
   return ''
 }
 get isConfigEnabled(){
      if(window.WorkLLama.isConfigJSONEnabled==='true'){
        return true
      }
      return false
      }
  addDocuments() {
    this.addtionalDocument = new AdditionalDocument();
    this.uploadDocument = true;
    console.log('Inside addDocuments');
    // this.documentTypeList();
    this.selectedDocumentType = '';
  }

  additionalDocTypeMatches(): boolean {
    const ext = this.addtionalDocument.documentFile.name.match(
      /\.([^\.]+)$/,
    )[1];
    console.log('Extension is : ', ext);
    const allowedResumeFormat =
      vxm.configs.getGlobalConfigValue('ADDITIONAL_DOCUMENT_FORMATS') ||
      DEFAULT_ADDITIONAL_DOCUMENT_FORMATS;
    console.log('ext::' + ext);
    console.log('allowedResumeFormat::' + allowedResumeFormat);
    return allowedResumeFormat.includes(ext.toLowerCase());
  }

  checkDocumentFile(file: any) {
    setTimeout(() => {
      console.log(this.selectedDocument.documentId);
    }, 500);
  }

  transformDate(dttm: number): string {
    if (dttm === null) return '';
    if (typeof dttm === 'undefined') return '';
    return moment(dttm).format(this.getCompanyDateFormat.toUpperCase());
  }

  isDateInPast(dttm: number): boolean {
    if (dttm === null) return false;
    var result = new Date(dttm);
    result.setDate(result.getDate() + 1);
    dttm = result.getTime();
    var expDate = new Date(dttm);

    var now = new Date();
    if (now > expDate) return true;
    else return false;
  }

  showModelDialog(option: String) {
    this.editDeleteHeader =
      option === 'delete'
        ? this.$t('SkillsDetails_DeleteOptionNotAvailable').toString()
        : this.$t('SkillsDetails_EditOptionNotAvailable').toString();
    this.editDeleteBody =
      option === 'delete'
        ? this.$t('SkillsDetails_VerifiedDocumentCannotBeDeleted').toString()
        : this.$t('SkillsDetails_VerifiedDocumentCannotBeEdited').toString();
    this.$modal.show('verifieddocumentmodal');
  }

  get sectionName() {
    if (this.$route.name && this.$route.name === 'GuidedSignup') {
      const section = vxm.configs.ClientConfigs.profileWizardConfig.profileSections.find(
        (section) => section.sectionKey === 'MY_DOCUMENTS',
      );
      return section ? section.displayName : 'Documents';
    }
    const section = vxm.configs.ClientConfigs.userProfileConfig.profileSections.find(
      (section) => section.sectionKey === 'MY_DOCUMENTS',
    );
    return section ? section.displayName : 'Documents';
  }

  async downloadResume(fileGUID, name) {
    try {
      const authToken = vxm.users.getToken;
      const url = '/wl-profile-svc/api/v2/user-profile/view/resume/' + fileGUID;

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${authToken}`,
        },
      });

      if (!response.ok) {
        throw new Error('Failed to download resume');
      }

      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = name || 'Document';

      // Trigger a click event to initiate the download
      link.click();

      // Clean up the URL object after download
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error('Error downloading resume:', error);
    }
  }




  saveDocument() {
    const allowedResumeFormat =
      vxm.configs.getGlobalConfigValue('ADDITIONAL_DOCUMENT_FORMATS') ||
      DEFAULT_ADDITIONAL_DOCUMENT_FORMATS;
    console.log('.... saveDocument', allowedResumeFormat);
    const vm = this;
    let file = this.addtionalDocument.documentFile;
    if (!this.addtionalDocument.documentName) {
      this.$wlToastr(
        'error',
        this.$t('document-name-err-msg'),
        this.$t('myprofile.my-documents.additionaldocuments.header'),
      );
      return;
    }
    // if (
    //   this.addtionalDocument.documentFile &&
    //   this.addtionalDocument.documentFile.name.length > 50
    // ) {
    //   this.$wlToastr(
    //     'error',
    //     'Please Upload a File with file name within 50 characters',
    //     'Additional Documents',
    //   );
    //   return;
    // }
    if (!this.selectedDocumentType) {
      this.$wlToastr(
        'error',
        this.$t('document-type-err-msg'),
        this.$t('myprofile.my-documents.additionaldocuments.header'),
      );
      return;
    }
    if (!this.isDropBoxFileUploaded || this.dropBoxFile === 'cancel') {
      if (this.addtionalDocument.documentId === 0 && !file) {
        if (!file) {
          this.$wlToastr('error', this.$t('select-file-err-msg'), this.$t('myprofile.my-documents.additionaldocuments.header'));
          return;
        }
      }

      if (file && file.size > this.supportedFileSize) {
        this.$wlToastr(
          'error',
          this.$t('document-size-err-msg', { num: this.supportedFileSize / (1024 * 1024) }),
          this.$t('myprofile.my-documents.additionaldocuments.header'),
        );
        return;
      }

      // if (file && !this.additionalDocTypeMatches()) {
      //   this.$wlToastr(
      //     'error',
      //     'File type Not supported. Upload ' + allowedResumeFormat,
      //     'Additional Documents',
      //   );
      //   return;
      // }
    }

    if (
      typeof this.addtionalDocument.effectiveDTTMText != 'undefined' &&
      this.addtionalDocument.effectiveDTTMText != null
    ) {
      this.addtionalDocument.effetiveDTTM = this.$moment(
        this.addtionalDocument.effectiveDTTMText,
      )._d.getTime();
      if (!this.addtionalDocument.doesNotExpire) {
        if (
          typeof this.addtionalDocument.expiryDTTMText != 'undefined' &&
          this.addtionalDocument.expiryDTTMText != null
        ) {
          this.addtionalDocument.expiryDTTM = this.$moment(
            this.addtionalDocument.expiryDTTMText,
          )._d.getTime();
          if (
            this.addtionalDocument.effetiveDTTM >=
            this.addtionalDocument.expiryDTTM
          ) {
            this.$wlToastr(
              'error',
              this.$t('document-expire-err-msg'),
              this.$t('myprofile.my-documents.additionaldocuments.header'),
            );
            return;
          }
        }
      }
    }

    if (
      typeof this.addtionalDocument.expiryDTTMText != 'undefined' &&
      this.addtionalDocument.expiryDTTMText != null
    ) {
      if (
        typeof this.addtionalDocument.effectiveDTTMText === 'undefined' ||
        this.addtionalDocument.effectiveDTTMText == null
      ) {
        this.$wlToastr(
          'error',
          this.$t('document-start-err-msg'),
          this.$t('myprofile.my-documents.additionaldocuments.header'),
        );
        return;
      }
    }

    this.documentPayload = new AdditionalDocumentPayload();
    if (
      typeof this.addtionalDocument.effetiveDTTM != 'undefined' &&
      this.addtionalDocument.effetiveDTTM != null
    ) {
      this.documentPayload.effectiveDate = this.addtionalDocument.effetiveDTTM.toString();
    }
    if (
      typeof this.addtionalDocument.expiryDTTM != 'undefined' &&
      this.addtionalDocument.expiryDTTM != null
    ) {
      this.documentPayload.expiryDate = this.addtionalDocument.expiryDTTM.toString();
    }
    this.documentPayload.documentId = this.addtionalDocument.documentId;
    this.documentPayload.licenseState = this.addtionalDocument.licenseState;
    this.documentPayload.licenseNumber = this.addtionalDocument.licenseNumber;
    this.documentPayload.documentName = this.addtionalDocument.documentName;
    this.documentPayload.documentType = this.selectedDocumentType;
    this.documentPayload.doesNotExpire = this.addtionalDocument.doesNotExpire;
    if (file !== undefined && file !== null) {
      this.documentPayload.documentFile = file;
    }
    let respPromise: any;

    if (this.isDropBoxFileUploaded && this.dropBoxFile != 'cancel') {
      this.documentPayload.documentFile = this.dropBoxFile;
      respPromise = vxm.documents.uploadViaDropbox(this.documentPayload);
    } else {
      respPromise = vxm.documents.uploadAdditionalDocumentV2(
        this.documentPayload,
      );
    }
    Promise.all([respPromise]).then(async (values) => {
      if (values[0].meta.success) {
        this.resetAdditionalDocs();
        await vxm.documents.getUserDocumentData();
        this.documentList = vxm.documents.AdditionalDocumentList;
        this.updateDocuments();
        vm.$wlToastr(
          'success',
          vm.$t('document-saved-success-msg'),
          vm.$t('myprofile.my-documents.additionaldocuments.header'),
        );
      } else if (
          values[0].meta &&
          values[0].meta.error &&
          values[0].meta.error.displayMessage
        ) {
          vm.$wlToastr(
            'error',
            values[0].meta.error.displayMessage,
            vm.$t('myprofile.my-documents.additionaldocuments.header'),
          );
        } else {
          vm.$wlToastr(
            'error',
            vm.$t('document-upload-err-msg'),
            vm.$t('myprofile.my-documents.additionaldocuments.header'),
          );
        }
      })
      .catch((e) => {
        if (
          e &&
          e.response &&
          (e.response.status === 503 || e.response.status === 418)
        ) {
          vm.$wlToastr('error', vm.$t('ResumeDetails_SecurityRisk'));
        }
      });
  }

  getDocumentReplaced() {
    this.replaceUploadedDocument = !this.replaceUploadedDocument;
    // this.addtionalDocument = new AdditionalDocument();
    // this.addtionalDocument.documentId = 0;
  }

  editDocument(documentResponse: AdditionalDocResponse) {
    this.uploadDocument = true;
    this.replaceUploadedDocument = false;
    console.log('replaceUploadedDocument', this.replaceUploadedDocument);
    this.selectedDocument = documentResponse;
    this.addtionalDocument = new AdditionalDocument();
    this.addtionalDocument.documentId = documentResponse.documentId;
    this.addtionalDocument.licenseState = documentResponse.licenseState;
    this.addtionalDocument.licenseNumber = documentResponse.licenseNumber;
    this.addtionalDocument.documentName = documentResponse.name;
    // this.addtionalDocument.documentType = documentResponse.objectType;
    this.selectedDocumentType = documentResponse.objectType;

    this.addtionalDocument.docNameWithExtension =
      documentResponse.docNameWithExtension;
    this.addtionalDocument.doesNotExpire = documentResponse.doesNotExpire;
    if (
      typeof documentResponse.effectiveDTTM != 'undefined' &&
      documentResponse.effectiveDTTM !== null
    ) {
      this.addtionalDocument.effetiveDTTM = new Date(
        documentResponse.effectiveDTTM,
      ).getTime();
      this.addtionalDocument.effectiveDTTMText = this.$moment(
        documentResponse.effectiveDTTM,
      ).format('YYYY-MM-DD');
    }
    if (
      typeof documentResponse.expiryDTTM != 'undefined' &&
      documentResponse.expiryDTTM !== null
    ) {
      this.addtionalDocument.expiryDTTM = new Date(
        documentResponse.expiryDTTM,
      ).getTime();
      this.addtionalDocument.expiryDTTMText = this.$moment(
        documentResponse.expiryDTTM,
      ).format('YYYY-MM-DD');
    }
  }

  async deleteDocument(documentResponse: AdditionalDocResponse) {
    console.log(' documentId:' + documentResponse.documentId);
    const vm = this;
    const respPromise: any = vxm.documents.deleteAdditionalDocument(
      documentResponse.documentId,
    );
    const resp = await respPromise;
    if (resp.meta.success) {
      vm.$wlToastr(
        'success',
        vm.$t('document-delete-success-msg'),
        vm.$t('myprofile.my-documents.additionaldocuments.header'),
      );
      vxm.documents.removeAdditonalDocument(documentResponse);
      this.resetAdditionalDocs();
      this.updateDocuments();
    } else {
      vm.$wlToastr(
        'error',
        vm.$t('document-delete-error-msg'),
        vm.$t('myprofile.my-documents.additionaldocuments.header'),
      );
    }
  }

  async documentTypeList() {
    console.log(' inside documentType list:');
    const vm = this;
    console.log(' got the companycode', this.companyCode);
    await vxm.documents.getDocumentTypeList(this.companyCode);
    this.documentType = vxm.documents.DocumentTypeList;
  }

  async selectFromDropbox(documentId: number) {
    console.log('documentid :' + documentId);
    const vm = this;
    vm.documentPayload.documentId = documentId;
    vxm.documents
      .uploadDropboxFile(vm.documentPayload)
      .then(async (status: string) => {
        console.log('STATUS: select from Dropbox ', status);
        if (!!status && 'cancel' !== status) {
          console.log('setting dropbox to true');
          this.isDropBoxFileUploaded = true;
          this.dropBoxFile = status;
          this.dropBoxFileName = decodeURI(this.dropBoxFile);
          this.dropBoxFileName = this.dropBoxFileName.split('\\').pop();
          this.dropBoxFileName =
            this.dropBoxFileName && this.dropBoxFileName.length > 0
              ? this.dropBoxFileName.split('/').pop()
              : this.dropBoxFileName;
        } else {
          this.isDropBoxFileUploaded = false;
        }
      })
      .catch((err) => {
        vm.$wlToastr('error', vm.$t('document-upload-err-msg'), vm.$t('SkillsDetails_DocumentUpload'));
      });
  }

  resetAdditionalDocs() {
    this.uploadDocument = false;
    this.replaceUploadedDocument = false;
    this.isDropBoxFileUploaded = false;
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
    this.selectedDocument = new AdditionalDocResponse();
    this.addtionalDocument = new AdditionalDocument();
  }

  get isDropboxEnabled() {
    if (
      vxm.configs.getGlobalConfigBooelanValue('WL_DROPBOX_INTEGRATION_ENABLED')
    ) {
      if (vxm.configs.getGlobalConfigValue('DROPBOX_APP_KEY')) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  saveUserAttribute() {
    const uID = this.selectedUserAttribute.userAttributeId;
    const vm = this;
    const file = this.userAttributeDocument.userAttrDoc; //this.userAttrDoc;
    const allowedResumeFormat = vxm.configs.getGlobalConfigValue(
      'ALLOWED_RESUME_FORMATS',
    );
    if (!this.isDropBoxFileUploaded) {
      if (!this.editMode) {
        if (!file) {
          this.$wlToastr('error', this.$t('select-file-err-msg'), this.$t('skill.success.message.title'));
          return;
        }
      }
      if (file && file.size > this.supportedFileSize) {
        this.$wlToastr(
          'error',
          this.$t('License_FileSizeRestriction', {
            maxSize: this.supportedFileSize / (1024 * 1024),
          }),
          this.$t('skill.success.message.title'),
        );
        return;
      }

      // if (!this.skillDocTypeMatches()) {
      //   this.$wlToastr(
      //     'error',
      //     'File type Not supported. Upload ' + allowedResumeFormat,
      //     'Skills',
      //   );
      //   return;
      // }
    }

    if (!this.validateCredential()) return;

    this.effectiveDateStr = this.userAttributeDocument.effectiveDTTMText;

    if (file !== undefined && file !== null) {
      if (file.name.length > 49) {
        this.$wlToastr(
          'error',
          this.$t('License_FileNameRestriction'),
          this.$t('skill.success.message.title'),
        );
        return;
      }

      /*this.userAttributePayload.effectiveDate = this.userAttributeDocument.effetiveDTTM
        ? this.userAttributeDocument.effetiveDTTM.toString()
        : '';
      this.userAttributePayload.expiryDate = this.userAttributeDocument.expiryDTTM
        ? this.userAttributeDocument.expiryDTTM.toString()
        : '';*/

      this.userAttributePayload.documentName = file.name;
      this.userAttributePayload.documentFile = file;
      this.userAttributePayload.uid = uID;
      this.userAttributePayload.documentId = this.selectedUserAttribute.documentId;

      this.userAttributePayload.document.documentName =
        '{"userAttributeId": ' + uID + '}';

      let respPromise: any;
      if (this.isDropBoxFileUploaded) {
        this.userAttributePayload.documentFile = this.dropBoxFile;
        respPromise = vxm.skills.uploadViaDropbox(this.userAttributePayload);
      } else {
        respPromise = vxm.skills.uploadSkillDocument(this.userAttributePayload);
      }
      Promise.all([respPromise]).then(async (values) => {
        this.isDropBoxFileUploaded = false;
        this.dropBoxFile = '';
        this.dropBoxFileName = '';
        console.log('successfully uploaded doc' + values[0]);
        if (values[0].success) {
          //vxm.users.getProfileStrength();
          //await vxm.users.getUserProfileAndNavigateTo('Skills');
          //vxm.users.getSkills();
          this.selectedUserAttribute.docNameWithExtension = file.name;
          //this.selectedUserAttribute.documentId = values[0].documentId;
          vm.$wlToastr('success', vm.$t('document-saved-success-msg'), vm.$t('skill.success.message.title'));
          await vxm.documents.getMyDocumentData();
          this.myDocumentList = vxm.documents.MyDocumentList;
          this.updateDocuments();
        } else {
          vm.$wlToastr('error', vm.$t('document-upload-err-msg'), vm.$t('skill.success.message.title'));
        }
      });
      this.selectedUserAttribute.docNameWithExtension = file.name;
      this.userAttributeDocument = new SkillDocument();
      this.selectedUserAttribute = new DocumentResponse();
    } else {
      /*this.userAttributePayload.effectiveDate = this.userAttributeDocument.effetiveDTTM
        ? this.userAttributeDocument.effetiveDTTM.toString()
        : null;
      this.userAttributePayload.expiryDate = this.userAttributeDocument.expiryDTTM
        ? this.userAttributeDocument.expiryDTTM.toString()
        : null;*/
      this.userAttributePayload.uid = uID;
      this.userAttributePayload.documentId = this.selectedDocument.documentId;
      this.userAttributePayload.document.documentName =
        '{"userAttributeId": ' + uID + '}';
      let respPromise: any;

      if (this.isDropBoxFileUploaded) {
        this.userAttributePayload.documentFile = this.dropBoxFile;
        respPromise = vxm.skills.uploadViaDropbox(this.userAttributePayload);
      } else {
        respPromise = vxm.skills.uploadSkillDocument(this.userAttributePayload);
      }

      Promise.all([respPromise])
        .then(async (values) => {
          console.log('successfully uploaded doc' + values[0]);
          this.isDropBoxFileUploaded = false;
          this.dropBoxFile = '';
          this.dropBoxFileName = '';
          if (values[0].success) {
            // vxm.users.getProfileStrength();
            //await vxm.users.getUserProfileAndNavigateTo('Skills');
            this.selectedUserAttribute.docNameWithExtension = file.name;
            //this.selectedUserAttribute.documentId = values[0].documentId;
            //vxm.users.getSkills();
            vm.$wlToastr('success', vm.$t('document-saved-success-msg'), vm.$t('skill.success.message.title'));
          } else {
            vm.$wlToastr('error', vm.$t('document-upload-err-msg'), vm.$t('skill.success.message.title'));
          }
        })
        .catch((e) => {
          if (
            e &&
            e.response &&
            (e.response.status === 503 || e.response.status === 418)
          ) {
            this.$wlToastr('error', this.$t('ResumeDetails_SecurityRisk'));
          }
        });

      this.userAttributeDocument = new SkillDocument();
      this.selectedUserAttribute = new DocumentResponse();
      this.editMode = false;
      this.documentExpires = false;
    }

    this.uploadUserAttribute = false;
    //vm.$wlToastr('success', vm.$t('document-saved-success-msg'), vm.$t('skill.success.message.title'));
  }

  validateCredential() {
    if (this.selectedUserAttribute.licenseStateFlag && !this.licenseState) {
      this.$wlToastr('error', 
        this.$t('SkillsDetails_EnterLicenseState'), 
        this.$t('myprofile.my-documents.credentials.header'));
      return false;
    }
    if (this.selectedUserAttribute.licenseNumberFlag && !this.licenseNumber) {
      this.$wlToastr(
        'error',
        this.$t('SkillsDetails_EnterLicenseNumber'),
        this.$t('myprofile.my-documents.credentials.header'),
      );
      return false;
    }

    if (
      this.selectedUserAttribute.effectiveDTTMFlag &&
      !this.effectiveDTTMText
    ) {
      this.$wlToastr(
        'error',
        this.$t('License_EnterEffectiveDate'),
        this.$t('myprofile.my-documents.credentials.header'),
      );
      return false;
    }

    if (this.selectedUserAttribute.expiryDTTMFlag && !this.expiryDTTMText) {
      this.$wlToastr(
        'error',
        this.$t('License_EnterExpiryDate'),
        this.$t('myprofile.my-documents.credentials.header'),
      );
      return false;
    }

    this.userAttributePayload.licenseState = this.licenseState;
    this.userAttributePayload.licenseNumber = this.licenseNumber;

    if (this.effectiveDTTMText) {
      this.userAttributePayload.effectiveDate = this.$moment(
        this.effectiveDTTMText,
      )
        .startOf('day')
        ._d.getTime();
    } else {
      this.userAttributePayload.effectiveDate = null;
    }
    if (this.expiryDTTMText) {
      this.userAttributePayload.expiryDate = this.$moment(this.expiryDTTMText)
        .startOf('day')
        ._d.getTime();
    } else {
      this.userAttributePayload.expiryDate = null;
    }

    if (
      this.userAttributePayload.effectiveDate &&
      this.userAttributePayload.expiryDate &&
      this.userAttributePayload.effectiveDate >=
        this.userAttributePayload.expiryDate
    ) {
      this.$wlToastr('error', this.$t('document-expire-err-msg'), this.$t('skill.success.message.title'));
      return false;
    }
    return true;
  }

  skillDocTypeMatches(): boolean {
    if (!this.userAttributeDocument.userAttrDoc) {
      return true;
    }
    const ext = this.userAttributeDocument.userAttrDoc.name.match(
      /\.([^\.]+)$/,
    )[1];
    const allowedResumeFormat =
      vxm.configs.getGlobalConfigValue('ADDITIONAL_DOCUMENT_FORMATS') ||
      '.pdf, .txt, .doc, .docx, .heic';
    return allowedResumeFormat.includes(ext.toLowerCase());
  }

  showDocumentsPopUp(userAttributeID: number) {
    this.userAttributeID = userAttributeID;
    //this.replaceUploadedDocumentEdit = false;
    this.userAttributeDocument = new SkillDocument();
    this.showModalEdit = true;
  }

  cancelUserAttributeUpload() {
    // this.replaceUploadedDocumentEdit = false;
    this.uploadUserAttribute = false;
  }

  //Landing page upload
  selectUserAttrDocumentWrapper(userAttribute) {
    this.selectedUserAttribute = userAttribute;
    this.userAttributeID = userAttribute.userAttributeId;
    this.userAttributeDocument = new SkillDocument();
    // this.showModal = true;
    this.uploadUserAttribute = true;
    this.editMode = false;
    this.documentExpires = false;
    this.licenseState = '';
    this.licenseNumber = '';
  }

  checkUserAttrDoc(file: any) {
    console.log(file);
    // if(!file) return;
    this.validCredential = true;
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
    this.isDropBoxFileUploaded = false;
  }

  checkUserAttrDocEdit(file: any) {
    this.dropBoxFile = '';
    this.dropBoxFileName = '';
    this.isDropBoxFileUploaded = false;
  }

  async deleteSkillAttributeDoc(documentResponse: DocumentResponse) {
    console.log(
      'skill details - skillAttributenumber:' +
        documentResponse.userAttributeId +
        ' documentId:' +
        documentResponse.documentId,
    );
    const vm = this;
    const respPromise: any = vxm.skills.deleteSkillAttributeDoc(
      documentResponse,
    );
    const resp = await respPromise;
    if (resp.success) {
      vxm.users.removeUserAttributeDoc(documentResponse.userAttributeId);
      vxm.users.getProfileStrength();
      vm.$wlToastr('success', resp.successMessage, vm.$t('skill.success.message.title'));
      await vxm.documents.getMyDocumentData();
      this.myDocumentList = vxm.documents.MyDocumentList;
      this.updateDocuments();
    } else {
      vm.$wlToastr('error', resp.errorMessage, vm.$t('skill.success.message.title'));
    }
  }
}
